<template>
  <div v-if="loading" class="spinner-container">
    <div class="spinner"></div>
  </div>
  
  <div v-else class="app-container">
    <!-- Header -->
    <header class="app-header">
      <div class="header-content">
        <div class="back-button" @click="goBack()">
          <i class="bi bi-arrow-left"></i>
        </div>
        <div class="header-title">
          <h2>{{ language?.invocie || 'Invoice' }}</h2>
        </div>
        <div class="header-action">
       
        </div>
      </div>
    </header>

    <!-- Main Content -->
    <main class="main-content">

      <!-- Staff List Section -->
     <div class="staff-section">
  <div class="section-header mb-3">
    <!-- <p class="staff-count">{{ accountinglist.length }} exam</p> -->
  </div>

  <!-- Empty State -->
  <div v-if="invoicedetails.length === 0" class="empty-state text-center py-5">
    <div class="empty-icon mb-3">
      <i class="bi bi-clipboard-x fs-1 text-muted"></i>
    </div>
    <h5>No Exam added</h5>
    <p class="text-muted">Add Exam to get started</p>
  </div>

  <!-- Table -->
  <div v-else>


<div class="invoice-wrapper" v-if="invoicedetails">

  <div class="invoice-card">

    <!-- Header -->
    <div class="invoice-header">
      <h2>🎵 Kalapini Sangeet Vidhyalay 🎵</h2>
      <p>Music • Dance • Culture</p>
    </div>

    <div class="invoice-title">
      INVOICE
    </div>

    <!-- Invoice Meta -->
    <div class="invoice-meta">
      <div>
        <strong>Invoice No:</strong> INV-{{ invoicedetails.id }}
      </div>
      <div>
        <strong>Date:</strong> {{ invoicedetails.entry_date }}
      </div>
    </div>

    <hr />

    <!-- Student Details -->
    <div class="invoice-section">
      
      <h4>Student Details</h4>
           <div class="d-flex gap-2">
      <div class="row">
   
        <span>Student ID</span>
        <span>{{ invoicedetails.studentid }}</span>
      </div>
      <div class="row">
        <span>Student Name</span>
        <span>{{ invoicedetails.student_name || 'N/A' }}</span>
      </div>
      <div class="row">
        <span>Course / Exam</span>
        <span>{{ invoicedetails.exam_name || 'Music Training Fees' }}</span>
      </div>
    </div>
    </div>

    <!-- Payment Details -->
    <div class="invoice-section">
      <h4>Payment Details</h4>
     
      <div class="row paid">
        <span>Paid Amount</span>
        <span class="right">₹{{ invoicedetails.paid }}</span>
      </div>

      <hr>

       <div class="total-row">
        <span><strong>Total Fees</strong></span>  <span class="text-end">₹{{ invoicedetails.total }}</span>
       
      </div>
      <hr>
      
        <div class="total-row">
        <span class="text-danger"><strong>Due Fees</strong></span>  <span>₹{{ Math.max(0, Number(invoicedetails.total) - Number(invoicedetails.paid)) }}</span>
       
      </div>

    </div>

    <!-- Notes -->
    <div class="invoice-section">
      <h4>Note</h4>
      <p>{{ invoicedetails.note || 'Thank you for supporting classical music.' }}</p>
    </div>

    <hr />

    <!-- Footer -->
    <div class="invoice-footer">
      <div class="status">
        Status:
        <span class="paid-badge">PAID</span>
      </div>

      <div class="signature">
        <div class="sign-line"></div>
        <small>Authorized Signature</small>
      </div>
    </div>

    <div class="thankyou">
      🙏 Thank you for learning Indian Classical Music 🙏
    </div>

  </div>
</div>
















  </div>
</div>




















      
    </main>


  </div>
</template>

<script> 
import axios from "@/plugins/axios";  

export default {
  name: 'Branch',
  mounted() { 
    if(this.$route.query.id){
         this.getBranches(this.$route.query.id);
    }else{
    this.getBranches();

    }

  },
  data() {
    const todayDate = new Date().toISOString().slice(0, 10);
    return { 
      loading: false,
      error: null,
      isUserLogged: false,
      user_details: [],
      invoicedetails:[],
      language: this.getLocalStorageArray('lang'),
    }
  },
  methods: {
 
    
    goBack() {
      this.$router.go(-1);
    },
    
    goprevious() {
      this.$router.push("/branch");
    },

    async getBranches(id) {
      this.loading = true;
      this.error = null;
  
      try {
        var self = this;
        axios.post("getinvoicedetails", { id: id }).then((response) => {
          self.invoicedetails = response.data.invoicedetails;

          localStorage.setItem('lang', response.data.language);
        }).then(() => {
        
   
           

                          self.initializeHomeContent();









        }).catch((err) => {
          console.error(err);
        });
      } catch (err) {
        this.error = err.response?.data?.message || "Request failed. Please try again.";
      } finally {
        this.loading = false;
      }
    }, 



    getLocalStorageArray(key) {
      let data = localStorage?.getItem(key);
      try {
        return data ? JSON.parse(data) : [];
      } catch (e) {
        console.error("Error parsing localStorage data", e);
        return [];
      }
    },
             














  }
}
</script>

<style scoped>
.app-container {
  min-height: 100vh;
  background: #f5f7fa;
}

.spinner-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
}

.spinner {
  width: 50px;
  height: 50px;
  border: 5px solid #f3f3f3;
  border-top: 5px solid #0056c2;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.app-header {
  background: linear-gradient(135deg, #0056c2 0%, #003a75 100%);
  color: white;
  padding: 16px;
  position: sticky;
  top: 0;
  z-index: 100;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.header-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.back-button {
  font-size: 20px;
  cursor: pointer;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: background 0.3s;
}

.back-button:active {
  background: rgba(255, 255, 255, 0.2);
}

.header-title h2 {
  margin: 0;
  font-size: 20px;
  font-weight: 600;
}

.btn-add {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.2);
  border: none;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  transition: all 0.3s;
}

.btn-add:active {
  background: rgba(255, 255, 255, 0.3);
  transform: scale(0.95);
}

.main-content {
  padding: 20px 16px;
  padding-bottom: 80px;
}

.section-header {
  margin-bottom: 16px;
}

.section-header h3 {
  margin: 0 0 8px;
  font-size: 18px;
  color: #2c3e50;
  font-weight: 600;
}

.staff-count {
  margin: 0;
  font-size: 14px;
  color: #7f8c8d;
}

.csv-section {
  margin-bottom: 24px;
}

.csv-card {
  background: white;
  border-radius: 16px;
  padding: 20px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.csv-content {
  display: flex;
  align-items: center;
  gap: 16px;
}

.csv-icon {
  width: 50px;
  height: 50px;
  background: rgba(76, 175, 80, 0.1);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  color: #4caf50;
}

.csv-info h4 {
  margin: 0 0 4px;
  font-size: 16px;
  color: #2c3e50;
}

.csv-info p {
  margin: 0;
  font-size: 14px;
  color: #7f8c8d;
}

.btn-csv {
  background: #4caf50;
  color: white;
  border: none;
  border-radius: 8px;
  padding: 10px 16px;
  font-size: 14px;
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  transition: all 0.3s;
}

.btn-csv:active {
  background: #388e3c;
  transform: scale(0.98);
}

.staff-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.staff-card {
  background: white;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
}

.staff-card-content {
  display: flex;
  align-items: center;
  padding: 16px;
  gap: 16px;
}

.staff-avatar {
  width: 50px;
  height: 50px;
  background: rgba(0, 86, 194, 0.1);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  color: #0056c2;
  flex-shrink: 0;
}

.staff-info {
  flex: 1;
}

.staff-header {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
}

.staff-header h4 {
  margin: 0;
  font-size: 16px;
  color: #2c3e50;
  font-weight: 600;
}

.staff-badge {
  padding: 4px 8px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 600;
}

.badge-admin {
  background: rgba(156, 39, 176, 0.1);
  color: #9c27b0;
}

.badge-staff {
  background: rgba(33, 150, 243, 0.1);
  color: #2196f3;
}

.staff-details p {
  margin: 4px 0;
  font-size: 14px;
  color: #7f8c8d;
  display: flex;
  align-items: center;
  gap: 8px;
}

.staff-status {
  margin-top: 8px;
}

.status-indicator {
  padding: 4px 10px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 600;
}

.status-indicator.active {
  background: rgba(76, 175, 80, 0.1);
  color: #4caf50;
}

.status-indicator.inactive {
  background: rgba(244, 67, 54, 0.1);
  color: #f44336;
}

.staff-actions {
  display: flex;
  padding: 0 16px 16px;
  gap: 8px;
  justify-content: flex-end;
}

.btn-action {
  width: 40px;
  height: 40px;
  border-radius: 8px;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  transition: all 0.3s;
}

.btn-action:active {
  transform: scale(0.95);
}

.btn-action.edit {
  background: rgba(33, 150, 243, 0.1);
  color: #2196f3;
}

.btn-action.delete {
  background: rgba(244, 67, 54, 0.1);
  color: #f44336;
}

.empty-state {
  text-align: center;
  padding: 40px 20px;
  color: #7f8c8d;
}

.empty-icon {
  font-size: 60px;
  margin-bottom: 16px;
  opacity: 0.5;
}

.empty-state h3 {
  margin: 0 0 8px;
  font-size: 18px;
}

.empty-state p {
  margin: 0;
  font-size: 14px;
}

/* Offcanvas Styles */
.offcanvas-header {
  padding: 16px;
  border-bottom: 1px solid #e9ecef;
}

.offcanvas-back {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background 0.3s;
  margin-right: 12px;
}

.offcanvas-back:active {
  background: #f5f7fa;
}

.offcanvas-title {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #2c3e50;
}

.offcanvas-body {
  padding: 16px;
}

.form-group {
  margin-bottom: 20px;
}

.form-group label {
  display: block;
  margin-bottom: 8px;
  font-weight: 600;
  color: #2c3e50;
  font-size: 14px;
}

.form-control, .form-select {
  width: 100%;
  padding: 2px 5px;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  font-size: 16px;
  transition: border-color 0.3s;
}

.form-control:focus, .form-select:focus {
  outline: none;
  border-color: #0056c2;
  box-shadow: 0 0 0 3px rgba(0, 86, 194, 0.1);
}

.form-actions {
  display: flex;
  gap: 12px;
  margin-top: 24px;
}

.btn {
  flex: 1;
  padding: 12px 20px;
  border: none;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s;
}

.btn:active {
  transform: scale(0.98);
}

.btn-primary {
  background: #0056c2;
  color: white;
}

.btn-primary:active {
  background: #003a75;
}

.btn-secondary {
  background: #f5f7fa;
  color: #7f8c8d;
}

.btn-secondary:active {
  background: #e9ecef;
}

@media (max-width: 480px) {
  .csv-card {
    flex-direction: column;
    gap: 16px;
    align-items: flex-start;
  }
  
  .staff-card-content {
    flex-direction: column;
    align-items: flex-start;
    text-align: left;
  }
  
  .staff-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
  }
}
.text-sm{
    font-size: 14px;
}







.invoice-wrapper {
  display: flex;
  justify-content: center;
  padding: 20px;
  background: #f5f6f8;
}

/* Card */
.invoice-card {
  width: 100%;
  max-width: 480px;
  background: #fffdf8;
  padding: 20px;
  border-radius: 10px;
  font-family: "Segoe UI", Arial, sans-serif;
  box-shadow: 0 8px 25px rgba(0,0,0,0.15);
  border: 1px solid #e0d6c6;
}

/* Header */
.invoice-header {
  text-align: center;
}

.invoice-header h2 {
  margin: 0;
  font-size: 20px;
  color: #7b2c2c;
}

.invoice-header p {
  margin: 4px 0 10px;
  font-size: 13px;
  color: #555;
}

/* Invoice Title */
.invoice-title {
  text-align: center;
  font-size: 18px;
  font-weight: bold;
  letter-spacing: 2px;
  margin: 10px 0;
  color: #333;
}

/* Meta */
.invoice-meta {
  display: flex;
  justify-content: space-between;
  font-size: 13px;
  margin-bottom: 10px;
}

/* Section */
.invoice-section {
  margin-top: 12px;
}

.invoice-section h4 {
  margin-bottom: 6px;
  font-size: 14px;
  color: #444;
  border-bottom: 1px dashed #ccc;
  padding-bottom: 4px;
}

.invoice-section .row {
  display: flex;
  justify-content: space-between;
  margin-bottom: 6px;
  font-size: 14px;
}

.invoice-section .highlight {
  font-weight: 600;
}

.invoice-section .paid {
  font-weight: 600;
  color: #1e7e34;
}

/* Footer */
.invoice-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 15px;
}

.paid-badge {
  background: #28a745;
  color: #fff;
  padding: 4px 12px;
  border-radius: 20px;
  font-size: 12px;
}

.signature {
  text-align: center;
}

.sign-line {
  width: 120px;
  border-top: 1px solid #000;
  margin-bottom: 4px;
}

/* Thank you */
.thankyou {
  text-align: center;
  margin-top: 15px;
  font-size: 13px;
  color: #7b2c2c;
  font-style: italic;
}

/* Mobile */
@media (max-width: 480px) {
  .invoice-card {
    padding: 15px;
    font-size: 13px;
  }

  .invoice-meta {
    flex-direction: column;
    gap: 4px;
  }

  .invoice-footer {
    flex-direction: column;
    gap: 10px;
    align-items: flex-start;
  }
}

/* Print */
@media print {
  body {
    background: white;
  }

  .invoice-wrapper {
    padding: 0;
  }

  .invoice-card {
    box-shadow: none;
    border: 1px solid #000;
  }
}

.total-row{
  display: flex;
  justify-content: space-between;
}

.paid{
  display: flex;
}

.paid .right{
  margin-left: auto;
  text-align: right;
}




</style>